import { render, staticRenderFns } from "./ModelNotes.vue?vue&type=template&id=4ff0215c&"
import script from "./ModelNotes.vue?vue&type=script&lang=js&"
export * from "./ModelNotes.vue?vue&type=script&lang=js&"
import style0 from "./ModelNotes.vue?vue&type=style&index=0&id=4ff0215c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports